export default __webpack_public_path__ + "static/vision-cover-ef7c40c6831b6953ac5f576fa0939da8.jpg";